// extracted by mini-css-extract-plugin
export default {"marginAfterPM":"Section2_marginAfterPM__EK141","margin":"Section2_margin__H2jh0"};